


// BUTTON FONTS
  (function () {
    function wrapLastWord(button) {
      // Skip if already processed
      if (button.querySelector('.button-last-word')) return;

      // Skip if the button only has one word total
      var fullText = button.textContent.trim();
      var wordCount = fullText === '' ? 0 : fullText.split(/\s+/).length;
      if (wordCount <= 1) return;

      var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      var lastTextNode = null;
      var node;
      while ((node = walker.nextNode())) {
        if (node.textContent.trim() !== '') lastTextNode = node;
      }
      if (!lastTextNode) return;

      var text = lastTextNode.textContent;
      var match = text.match(/(\s*)(\S+)(\s*)$/);
      if (!match) return;

      var before = text.slice(0, match.index) + match[1];
      var lastWord = match[2];
      var after = match[3];

      var frag = document.createDocumentFragment();
      frag.appendChild(document.createTextNode(before));

      var span = document.createElement('span');
      span.className = 'button-last-word';
      span.textContent = lastWord;
      frag.appendChild(span);

      frag.appendChild(document.createTextNode(after));

      lastTextNode.parentNode.replaceChild(frag, lastTextNode);
    }

    function processAll(root) {
      root.querySelectorAll('.button').forEach(wrapLastWord);
    }

    // Initial pass
    processAll(document);

    // Catch buttons added later (cart drawer, quick add, AJAX sections, etc.)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (added) {
          if (added.nodeType !== 1) return;
          if (added.matches && added.matches('.button')) wrapLastWord(added);
          if (added.querySelectorAll) processAll(added);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  })();




  

// VARIANT WRAPPER
function wrapConsecutiveVariantWrappers() {
  const wrappers = document.querySelectorAll('.variant-wrapper');
  let group = [];

  function flushGroup() {
    if (group.length === 0) return;

    const container = document.createElement('div');
    container.className = 'variant-container';

    // Insert the container right before the first element in the group
    group[0].parentNode.insertBefore(container, group[0]);

    // Move each element in the group into the container
    group.forEach(el => container.appendChild(el));

    group = [];
  }

  wrappers.forEach((el, i) => {
    if (group.length === 0) {
      group.push(el);
    } else {
      const prev = group[group.length - 1];
      // Check if el is the next sibling of prev (i.e. consecutive, no gap)
      if (prev.nextElementSibling === el) {
        group.push(el);
      } else {
        flushGroup();
        group.push(el);
      }
    }
  });

  flushGroup(); // handle the last group
}

wrapConsecutiveVariantWrappers();



// VIDEOS
(function () {
  gsap.registerPlugin(ScrollTrigger);

  // --- Browser detection ---------------------------------------------
  // Safari (desktop + iOS) added *silent* webm/VP9 playback support in
  // recent versions, but it does NOT support VP9 alpha in webm. Since our
  // <source> lists put webm first, Safari happily "plays" it and renders
  // the transparent areas as solid black. The fix: don't let the browser
  // choose — explicitly hand Safari the HEVC+Alpha .mov file and hand
  // everyone else the VP9+Alpha .webm file.
  function isSafari() {
    var ua = navigator.userAgent;
    var isAppleWebkit = /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(ua);
    var isIOS = /iP(ad|hone|od)/.test(ua) && !window.MSStream;
    return isAppleWebkit || isIOS;
  }

  var USE_SAFARI_SOURCES = isSafari();

  // Given an entry's full sources array (webm + mov), return just the
  // one appropriate source for this browser, wrapped in an array so the
  // rest of the code doesn't need to change.
  function pickSource(sources) {
    if (!sources || !sources.length) return [];
    if (USE_SAFARI_SOURCES) {
      var mov = sources.filter(function (s) { return s.type === 'video/quicktime'; });
      return mov.length ? mov : sources; // fallback just in case
    }
    var webm = sources.filter(function (s) { return s.type === 'video/webm'; });
    return webm.length ? webm : sources; // fallback just in case
  }

  var DREAMING_VIDEOS = [
    {
      selector: '.dreaming-hero',
      id: '1',
      style: 'margin-left:-5px; margin-top: 0px;',
      playbackRate: 1,
      sources: [
        { src: 'https://cdn.shopify.com/videos/c/o/v/a8003432da654a01b95854a6c533506d.webm', type: 'video/webm' },
        { src: 'https://cdn.shopify.com/videos/c/o/v/dbe844cd9a504335b5d1ee97a28ca5a1.mov', type: 'video/quicktime' }
      ]
    },
    {
      selector: '.dreaming-2',
      id: '2',
      style: 'margin-left:4px; margin-top: -1px;',
      playbackRate: 1,
      sources: [
        { src: 'https://cdn.shopify.com/videos/c/o/v/394d6de64e214224b3c7600a38ffbfdb.webm', type: 'video/webm' },
        { src: 'https://cdn.shopify.com/videos/c/o/v/526124f154e2496a9f0d26ea1469a527.mov', type: 'video/quicktime' }
      ]
    },
    {
      selector: '.dreaming-3',
      id: '3',
      playbackRate: 1,
      style: 'margin-left:3px; margin-top: 0px;',
      sources: [
        { src: 'https://cdn.shopify.com/videos/c/o/v/8ba0691df4b44cf3a6896944d9c96d90.webm', type: 'video/webm' },
        { src: 'https://cdn.shopify.com/videos/c/o/v/130db9bf67244f678b32d2a3ae8b36a9.mov', type: 'video/quicktime' }
      ]
    },
    {
      selector: '.dreaming-4',
      id: '4',
      playbackRate: 1,
      style: 'margin-left:-20px; margin-top: 0px;',
      sources: [
        { src: 'https://cdn.shopify.com/videos/c/o/v/b64be85a80764d80a349db3462b77712.webm', type: 'video/webm' },
        { src: 'https://cdn.shopify.com/videos/c/o/v/5c8a44ac6b6c4d7f988d296da6c75532.mov', type: 'video/quicktime' }
      ]
    },
    {
      selector: '.dreaming-5',
      id: '5',
      playbackRate: 1,
      style: 'margin-left:-18px; margin-top: -30px;',
      sources: [
        { src: 'https://cdn.shopify.com/videos/c/o/v/f2f5af84a55d4392b86cdba101a9af6c.webm', type: 'video/webm' },
        { src: 'https://cdn.shopify.com/videos/c/o/v/3b68f0ea485b444ab6286da05995cf02.mov', type: 'video/quicktime' }
      ]
    },
    {
      selector: '.dreaming-6',
      id: '6',
      playbackRate: 1,
      style: 'margin-left:-18px; margin-top: -9px;',
      sources: [
        { src: 'https://cdn.shopify.com/videos/c/o/v/505c3d2d7b124421815636b436302715.webm', type: 'video/webm' },
        { src: 'https://cdn.shopify.com/videos/c/o/v/e0da0fdde0b44bb6a55a9667c723ec63.mov', type: 'video/quicktime' }
      ],
      hoverAlt: {
        corner: 'bottom-right',
        cornerSizePercent: 25,
        sources: [
          { src: 'https://cdn.shopify.com/videos/c/o/v/746bde0d0f074abcbd25b2a7e0f9c49f.webm', type: 'video/webm' },
          { src: 'https://cdn.shopify.com/videos/c/o/v/6ddc275dd8cf45f19c1e4a47e3a75850.mov', type: 'video/quicktime' }
        ]
      }
    }
  ];

  function buildVideo(entry, isAlt) {
    var video = document.createElement('video');
    video.className = 'dreaming-overlay-video' + (isAlt ? ' is-alt-video' : '');
    video.setAttribute('data-dreaming-video', isAlt ? entry.id + '-alt' : entry.id);
    video.muted = true;
    video.playsInline = true;
    video.setAttribute('preload', 'auto');

    // entry.style is applied ONLY to the wrapper now (see below) — not here at all,
    // for entries that use hoverAlt. For plain entries without hoverAlt, style still applies directly.
    if (entry.style && !entry.hoverAlt) {
      video.setAttribute('style', entry.style);
    }

    // FIX: overlay videos must never intercept clicks. Previously nothing
    // set pointer-events on these elements until AFTER a hover-swap fired,
    // which meant the video's full bounding box sat on top of the page
    // (blocking links/buttons underneath) for its entire playback, and
    // permanently for any entry without a hoverAlt at all. Since none of
    // this module's interactions actually require the video itself to be
    // the event target anymore (corner-hover is detected via rect math on
    // a container-level listener instead), it's safe to disable pointer
    // events on every overlay video unconditionally.
    video.style.pointerEvents = 'none';

    if (entry.playbackRate) {
      video.playbackRate = entry.playbackRate;
      video.addEventListener('loadedmetadata', function () {
        video.playbackRate = entry.playbackRate;
      });
    }

    var allSources = isAlt ? entry.hoverAlt.sources : entry.sources;
    var sources = pickSource(allSources);
    sources.forEach(function (s) {
      var source = document.createElement('source');
      source.src = s.src;
      source.type = s.type;
      video.appendChild(source);
    });

    return video;
  }

  function buildImage(entry) {
    var img = document.createElement('img');
    img.className = 'dreaming-overlay-video';
    img.setAttribute('data-dreaming-video', entry.id);
    img.setAttribute('src', entry.src);
    img.setAttribute('alt', entry.alt || '');
    img.style.pointerEvents = 'none'; // FIX: same reasoning as buildVideo

    if (entry.style) {
      img.setAttribute('style', entry.style);
    }
    // re-apply after setAttribute('style', ...) above, since that call
    // replaces the whole style attribute and would wipe pointer-events
    img.style.pointerEvents = 'none';

    return img;
  }

  function isInCorner(event, targetEl, corner, sizePercent) {
    var rect = targetEl.getBoundingClientRect();
    var xPercent = ((event.clientX - rect.left) / rect.width) * 100;
    var yPercent = ((event.clientY - rect.top) / rect.height) * 100;
    var threshold = 100 - sizePercent;

    var isRight = corner.indexOf('right') !== -1 ? xPercent >= threshold : xPercent <= sizePercent;
    var isBottom = corner.indexOf('bottom') !== -1 ? yPercent >= threshold : yPercent <= sizePercent;

    var withinX = event.clientX >= rect.left && event.clientX <= rect.right;
    var withinY = event.clientY >= rect.top && event.clientY <= rect.bottom;

    return withinX && withinY && isRight && isBottom;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.querySelector('.dreaming-overlay');
    if (!overlay) return;

    // FIX: the overlay container itself must not block clicks either —
    // only the small set of elements that legitimately need to catch a
    // hover (handled via the document-level mousemove listener below,
    // which works fine against pointer-events:none targets because
    // getBoundingClientRect() is unaffected by pointer-events).
    overlay.style.pointerEvents = 'none';

    var entries = DREAMING_VIDEOS
      .map(function (entry) {
        var section = document.querySelector(entry.selector);
        if (!section) return null;

        var isImage = entry.type === 'image';

        if (entry.hoverAlt) {
          var wrapper = document.createElement('div');
          wrapper.className = 'dreaming-overlay-item-wrapper';
          if (entry.style) wrapper.setAttribute('style', entry.style); // style lives ONLY here now
          wrapper.style.pointerEvents = 'none'; // FIX

          var media = buildVideo(entry, false);
          var altMedia = buildVideo(entry, true);

          wrapper.appendChild(media);
          wrapper.appendChild(altMedia);
          overlay.appendChild(wrapper);

          media.classList.add('is-loaded');
          altMedia.classList.add('is-loaded'); // harmless now — CSS forces alt hidden until is-active

          // Prime the alt video on its first frame while paused, rather
          // than starting it cold on hover OR looping it continuously
          // in the background. preload="auto" means the browser starts
          // fetching/decoding as soon as this element exists, and by
          // "loadeddata" it has a real, paintable first frame sitting
          // ready — just not playing yet. That's what removes the flash:
          // when hover fires play(), there's already a decoded frame to
          // show instead of a blank gap while it spins up. It also means
          // playback genuinely starts from the beginning every time,
          // instead of hover catching it mid-loop.

          return {
            entry: entry,
            section: section,
            video: media,
            altVideo: altMedia,
            isImage: false,
            hasPlayed: false,
            hasTriggered: false,
            altActive: false,
            trigger: null
          };
        }

        var media = isImage ? buildImage(entry) : buildVideo(entry, false);
        overlay.appendChild(media);
        media.classList.add('is-loaded');

        return {
          entry: entry,
          section: section,
          video: media,
          altVideo: null,
          isImage: isImage,
          hasPlayed: isImage,
          hasTriggered: false,
          altActive: false,
          trigger: null
        };
      })
      .filter(Boolean);

    function activateItem(item) {
      if (item.hasTriggered) return;
      item.hasTriggered = true;

      item.video.classList.add('is-active');
      if (!item.isImage && !item.hasPlayed) {
        item.video.play().catch(function (err) {
          console.error('Video failed to play (' + item.entry.id + '):', err);
        });
      }
    }

    function advanceChain(index) {
      var next = entries[index + 1];
      if (!next) return;

      if (next.hasTriggered) {
        if (!next.isImage && !next.hasPlayed) {
          next.video.play().catch(function (err) {
            console.error('Video failed to play (' + next.entry.id + '):', err);
          });
        }
      } else {
        next.hasTriggered = true;
        next.video.classList.add('is-active');
        if (!next.isImage) {
          next.video.play().catch(function (err) {
            console.error('Video failed to play (' + next.entry.id + '):', err);
          });
        }
      }
    }

    function createTrigger(item) {
      return ScrollTrigger.create({
        trigger: item.section,
        start: 'top bottom',
        end: 'bottom center',
        onEnter: function () { activateItem(item); },
        onEnterBack: function () { activateItem(item); }
      });
    }

    // --- Reset logic ------------------------------------------------
    // Pauses/rewinds every video, clears all "already played/triggered"
    // state, and recreates each ScrollTrigger. GSAP evaluates a newly
    // created ScrollTrigger against the CURRENT scroll position right
    // away, so anything already sitting inside its start/end zone will
    // fire onEnter immediately — which is what makes mid-page videos
    // start playing the instant .dreaming is added to <body>.
    function resetItem(item) {
      if (item.trigger) {
        item.trigger.kill();
        item.trigger = null;
      }

      if (!item.isImage) {
        item.video.pause();
        try { item.video.currentTime = 0; } catch (e) {}
      }
      item.video.classList.remove('is-active');
      item.video.style.opacity = '';
      item.video.style.visibility = '';
      // NOTE: pointer-events intentionally left as 'none' — it's the
      // permanent default now, not a transient state to reset.

      if (item.altVideo) {
        item.altVideo.pause();
        try { item.altVideo.currentTime = 0; } catch (e) {}
        item.altVideo.classList.remove('is-active');
        item.altVideo.style.opacity = '';
        item.altVideo.style.visibility = '';
      }

      item.hasTriggered = false;
      item.hasPlayed = item.isImage;
      item.altActive = false;

      item.trigger = createTrigger(item);
    }

    function resetAllVideos() {
      entries.forEach(resetItem);
      ScrollTrigger.refresh();
    }

    function pauseAllVideos() {
      entries.forEach(function (item) {
        if (!item.isImage) item.video.pause();
        if (item.altVideo) item.altVideo.pause();
      });
    }

    entries.forEach(function (item, index) {
      if (!item.isImage) {
        item.video.addEventListener('ended', function () {
          console.log('Video ended: ' + item.entry.id);
          item.hasPlayed = true;
          advanceChain(index);
        });
      }

      item.trigger = createTrigger(item);

      if (item.entry.hoverAlt && item.altVideo) {
        item.video.style.transition = 'opacity 250ms ease';
        item.altVideo.style.transition = 'opacity 250ms ease';
      }
    });

    // --- Corner-hover detection (moved off the video elements) ------
    // FIX: this used to be a 'mousemove' listener attached directly to
    // each item.video, which required the video to have pointer-events
    // enabled to receive the event in the first place — that's what was
    // blocking clicks on anything underneath. Now it's a single listener
    // on `document`, and hit-testing is done purely with
    // getBoundingClientRect() math (isInCorner), which works regardless
    // of pointer-events. Nothing needs to be "on top" and clickable for
    // this to keep working.
    var CROSSFADE_MS = 250;

    document.addEventListener('mousemove', function (event) {
      entries.forEach(function (item) {
        if (!item.entry.hoverAlt || !item.altVideo) return;
        if (item.altActive) return;
        if (!item.hasPlayed) return;

        var corner = item.entry.hoverAlt.corner || 'bottom-right';
        var sizePercent = item.entry.hoverAlt.cornerSizePercent || 25;

        if (isInCorner(event, item.video, corner, sizePercent)) {
          console.log('Corner hover detected — swapping to alt video (' + item.entry.id + ')');
          item.altActive = true;

          // The alt video is primed on frame 0 (paused, already
          // decoded) rather than mid-loop, so starting it here plays
          // genuinely from the beginning. Because that first frame is
          // already ready, there's no blank gap between revealing it
          // and play() actually painting something.
          try { item.altVideo.currentTime = 0; } catch (e) {}

          item.altVideo.style.visibility = 'visible';
          item.altVideo.style.opacity = '1';
          item.altVideo.classList.add('is-active');
          item.altVideo.play().catch(function (err) {
            console.error('Alt video failed to play (' + item.entry.id + '):', err);
          });

          item.video.style.opacity = '0';

          window.setTimeout(function () {
            item.video.pause();
            item.video.classList.remove('is-active');
            item.video.style.visibility = 'hidden';
          }, CROSSFADE_MS);
        }
      });
    });

    // --- Watch <body> for .dreaming being toggled on/off ------------
    var bodyHasDreaming = document.body.classList.contains('dreaming');

    var bodyObserver = new MutationObserver(function () {
      var nowHasDreaming = document.body.classList.contains('dreaming');
      if (nowHasDreaming === bodyHasDreaming) return;
      bodyHasDreaming = nowHasDreaming;

      if (nowHasDreaming) {
        console.log('dreaming enabled — resetting video overlay');
        resetAllVideos();
      } else {
        console.log('dreaming disabled — pausing video overlay');
        pauseAllVideos();
      }
    });

    bodyObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  });
})();



//fox


(function () {
  gsap.registerPlugin(ScrollTrigger);

  document.addEventListener('DOMContentLoaded', function () {
    var videos = document.querySelectorAll('.c-image-list__dreaming-video');
    if (!videos.length) return;

    videos.forEach(function (video) {
      var slideTrigger = null;
      var wasDreaming = document.body.classList.contains('dreaming');

      function resetVideoPosition() {
        gsap.killTweensOf(video);
        gsap.set(video, { x: 0 });
      }

      function killSlideTrigger() {
        if (slideTrigger) {
          slideTrigger.kill();
          slideTrigger = null;
        }
      }

      function createSlideTrigger() {
        killSlideTrigger();
        slideTrigger = ScrollTrigger.create({
          trigger: video,
          start: 'top bottom',
          once: true,
          onEnter: function () {
            gsap.to(video, {
              x: function () {
                return window.innerWidth - video.getBoundingClientRect().left;
              },
              duration: 4,
              ease: 'power2.inOut'
            });
          }
        });
      }

      // If it's already dreaming on load, arm it right away
      if (wasDreaming) {
        createSlideTrigger();
      }

      var bodyObserver = new MutationObserver(function () {
        var isDreaming = document.body.classList.contains('dreaming');

        if (isDreaming && !wasDreaming) {
          // Turned ON: reset position, re-arm the slide-out
          resetVideoPosition();
          createSlideTrigger();
        } else if (!isDreaming && wasDreaming) {
          // Turned OFF: cancel any running tween, snap back for next time
          killSlideTrigger();
          resetVideoPosition();
        }

        wasDreaming = isDreaming;
      });

      bodyObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  });
})();




//FORM



function applyFormStyles() {
  const hostEl = document.querySelector('shopify-forms-embed');
  if (!hostEl || !hostEl.shadowRoot) return false;
  hostEl.shadowRoot.querySelector('style')?.insertAdjacentHTML('afterend', `
    <style>
      button._formSubmitButton_cit2d_96 {
        text-transform: uppercase !important;
      }

      input._formInputField_nag3b_7,
      input._formPhoneInputField_piv1u_17,
      ._selectToggle_12thd_25 {
        border-top: 0px !important;
        border-right: 0px !important;
        border-bottom: 1px solid var(--h-main) !important;
        border-left: 0px !important;
        border-radius: 0px !important;
        background-color: transparent !important;
        box-shadow: none !important;
      }

      ._formFileInputField_ehvsf_5 {
          background-color: transparent !important;
          color: var(--h-main) !important;
          border: 1px dashed var(--h-main) !important;
          border-radius: 0px !important;
      }

      ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
          max-width: 668px !important;
      }

      div._formDisclaimer_cit2d_38 p,
      ._formDisclaimer_jnbzb_38 p,
      ._formDisclaimer_jnbzb_38 p{
         text-align: center !important;
         font-style: italic !important;
         letter-spacing: 0px !important;
      }

      button._formSubmitButton_cit2d_96:before,
      button._formSubmitButton_jnbzb_106:before{
          content: "【" !important;
          position: relative !important;
          padding-right: 1ch !important;
      }

      button._formSubmitButton_cit2d_96:after,
      button._formSubmitButton_jnbzb_106:after{
          content: "】" !important;
          position: relative !important;
          padding-left: 1ch !important;
      }

      button._formSubmitButton_cit2d_96,
      _formSubmitButton_jnbzb_106,
      button {
          all: unset;
          display: flex;
          justify-content: center;
          font: 'Herbik' !important;
          letter-spacing: 10% !important;
          line-height: var(--forms-base-font-line-height);
          padding: var(--button-padding);
          background-color: transparent !important;
          text-transform: uppercase !important;
          color: var(--h-main) !important;
          border: none;
          box-shadow: none;
          outline: var(--button-border);
          outline-offset: 1px;
          border-radius: 0px !important;
          cursor: pointer;
      }

      ._formFileInputButton_ehvsf_18 {
          background-color: #FEF8E7 !important;
          font: var(--forms-body-font);
          color: var(--h-main) !important;
          line-height: 20px;

          border-radius: 0px !important;
      }

      input._formInputField_nag3b_7{
        color: var(--h-main) !important;
      }

      .phone-country-selector{
        display: flex !important;
      }

      label._formInputFieldLabel_1mxsl_38,
      p._textBody_2aowh_10,
      ._formFileInputButton_ehvsf_18{
        text-transform: uppercase !important;
        letter-spacing: 10% !important;
      }

      ._selectContainer_12thd_6 {
          min-width: 100% !important;
      }
 
      ._formPhoneInputContainer_piv1u_6{
        align-items: end !important;
      }

      div._formFieldContainer_1mxsl_5 label._formInputFieldLabel_1mxsl_38 {
        top: 25px !important;
        left: 0px !important;
        color: rgba(var(--h-main), 1) !important;
    
      }

      ._formPhoneInputContainer_piv1u_6 div._formFieldContainer_1mxsl_5 label._formInputFieldLabel_1mxsl_38 {
        top: 10px !important;
      }

      ._formFieldContainer_1mxsl_5:focus-within label._formInputFieldLabel_1mxsl_38 {
        top: 10px !important;
      }
    </style>
  `);
  return true;
}

document.addEventListener('DOMContentLoaded', () => {
  if (applyFormStyles()) return;
  const observer = new MutationObserver(() => {
    if (applyFormStyles()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});






